// init fancybox
function initFancybox() {
	Fancybox.bind("[data-fancybox]", {
		autoFocus: false,
		dragToClose: false,
		placeFocusBack: false,
	});
}

// Initialize all sliders
function initSliders() {

	const instagramSwiper = document.querySelector('.instagram-swiper');

	if (instagramSwiper) {
    const swiperInstance = new Swiper(instagramSwiper, {
      spaceBetween: 20,
      loop: true,
      speed: 5000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      },
			allowTouchMove: false,
			simulateTouch: false,
			preventClicks: false,
			preventClicksPropagation: false,
			touchStartPreventDefault: false,
      slidesPerView: 1.3,
      allowTouchMove: false,
      grabCursor: false,
      breakpoints: {
        575: { slidesPerView: 2.2 },
        767: { slidesPerView: 3 },
        992: { slidesPerView: 4 },
        1400: { slidesPerView: 5 },
      },
    });
	}

  const blogHomeSwiper = document.querySelector('.blog-home-slider');

	if (blogHomeSwiper) {
    const slider = new Swiper(blogHomeSwiper, {
      spaceBetween: 20,
      loop: false,
      slidesPerView: 1.1,
      allowTouchMove: true,
      navigation: {
        nextEl: '.blog-home-slider-nav .next',
        prevEl: '.blog-home-slider-nav .prev',
      },
      breakpoints: {
        767: { slidesPerView: 2.2 },
        1200: { slidesPerView: 3 }
      },
    });
	}

  const homeBannerSwiper = document.querySelector('.home-banner-slider');

	if (homeBannerSwiper) {
    const slider = new Swiper(homeBannerSwiper, {
      effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
      loop: true,
			spaceBetween: 0,
			slidesPerView: 1,
			allowTouchMove: window.matchMedia('(max-width: 767px)').matches,
			simulateTouch: false,
			threshold: 10,
			preventClicks: false,
			preventClicksPropagation: false,
			touchStartPreventDefault: false,
			autoplay: {
				delay: 6000,
				disableOnInteraction: false
			},
			pagination: {
				el: '.home-banner-slider-pagination',
				clickable: true
			}
    })
	}
}

// Initialize Mobile Menu
function initMobileMenu() {
  'use strict';
  
  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenuClose = document.getElementById('mobile-menu-close');
  const fsMenu = document.getElementById('fs-menu');
  const menuOverlay = document.getElementById('menu-overlay');
  
  if (!fsMenu || !menuOverlay) {
    return;
  }
  
  let isFsMenuOpen = false;
  
  // Open Mobile Menu
  function openFsMenu() {
    if (fsMenu && menuOverlay) {
      isFsMenuOpen = true;
      fsMenu.classList.remove('visibility-hidden', 'pointer-events-none');
      fsMenu.classList.add('!translate-x-0', '!opacity-100', '!pointer-events-auto');
      fsMenu.style.opacity = '1';
      menuOverlay.classList.add('!pointer-events-auto', 'opacity-30');
      document.body.style.overflow = 'hidden';
    }
  }
  
  // Close Mobile Menu
  function closeFsMenu() {
    if (fsMenu && menuOverlay) {
      isFsMenuOpen = false;
      fsMenu.classList.add('visibility-hidden', 'pointer-events-none');
      fsMenu.classList.remove('!translate-x-0', '!opacity-100', '!pointer-events-auto');
      fsMenu.style.opacity = '0';
      menuOverlay.classList.remove('!pointer-events-auto', 'opacity-30');
      document.body.style.overflow = '';
    }
  }
  
  // Close All (only closes mobile menu, cart drawer has its own handler)
  function closeAll() {
    closeFsMenu();
  }
  
  // Event Listeners
  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', openFsMenu);
  }
  
  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', closeFsMenu);
  }
  
  if (menuOverlay) {
    menuOverlay.addEventListener('click', closeAll);
  }
  
  // Close on ESC key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && isFsMenuOpen) {
      closeAll();
    }
  });
  
  // Close menu when clicking on links
  const fsMenuLinks = fsMenu.querySelectorAll('a');
  if (fsMenuLinks) {
    fsMenuLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        closeFsMenu();
      });
    });
  }
}

// Initialize Cart Drawer
function initCartDrawer() {
  'use strict';
  
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerOverlay = document.querySelector('[data-cart-drawer-overlay]');

  if (!cartDrawer || !cartDrawerOverlay) {
    return;
  }

  let isCartOpen = false;
  let closeTimer = null;

  // Escape HTML to prevent XSS
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text == null ? '' : text;
    return div.innerHTML;
  }

  // escapeHtml() leaves quotes intact, which is fine for text nodes but not for
  // values interpolated into attributes (line keys, URLs, titles used as labels).
  function escapeAttr(text) {
    return escapeHtml(text).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Cart Item Template — "Boutique" card (see snippets/cart-drawer.liquid for the CSS).
  // Styling uses scoped `pkcd-*` classes because Tailwind only scans .liquid files.
  // The BOGO pill badges the thumbnail itself (not the text column), and the
  // price + quantity stepper bottom-align with the thumbnail's bottom edge.
  //
  // Mutations are addressed by LINE KEY (`item.key` from /cart.js), never by
  // variant id: a cart can hold several lines of the same variant + selling plan
  // (the BOGO path pushes a paid line with properties and a free line without,
  // and the bulk-promotion discount splits lines too), so a variant-id lookup
  // resolves to the first match and mutates the wrong card. The key is carried on
  // data-cart-item-key and read by the delegated handler bound once in initCart().
  const cartItem = `
    <div class='pkcd-item' data-cart-item-key='%CART_KEY%'>
      <a href='%PRODUCT_URL%' class='pkcd-item__thumb' tabindex='-1' aria-hidden='true'>
        <img src='%PRODUCT_IMAGE%' alt='' width='88' height='88' loading='lazy'>
        %BOGO_BADGE%
      </a>

      <div class='pkcd-item__main'>
        <a href='%PRODUCT_URL%' class='pkcd-item__title'>%PRODUCT_TITLE%</a>
        %VARIANT_TITLE%
        %SELLING_PLAN_TEXT%

        <div class='pkcd-item__foot'>
          <p class='pkcd-item__price'>%PRODUCT_PRICE%</p>
          %QUANTITY_CONTROL%
        </div>
      </div>

      <button
        type='button'
        class='pkcd-item__remove'
        aria-label='Remove %PRODUCT_TITLE_ATTR% from cart'
        data-cart-line-action='remove'
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 18" fill="currentColor" aria-hidden="true"><path d="M15.031 2.813c.457 0 .844.386.844.843a.833.833 0 0 1-.844.844h-.422l-.843 11.426C13.66 17.12 12.71 18 11.516 18H4.449c-1.195 0-2.144-.879-2.25-2.074L1.355 4.5H.97c-.492 0-.844-.352-.844-.844 0-.457.352-.844.844-.844h2.426L4.695.88A2.02 2.02 0 0 1 6.348 0h3.27c.667 0 1.3.352 1.652.879l1.3 1.934zM6.348 1.687c-.106 0-.211.07-.246.141l-.668.984h5.097l-.668-.984a.3.3 0 0 0-.246-.14zM12.922 4.5H3.043l.844 11.32a.57.57 0 0 0 .562.492h7.067c.28 0 .527-.21.562-.492z"></path></svg>
      </button>
    </div>
  `;

  // Empty-cart state. The threshold copy reads from the drawer's
  // data-free-shipping-threshold so it tracks the Liquid setting.
  function cartEmptyMarkup() {
    const threshold = getShippingThreshold();
    const note = threshold > 0
      ? ` &mdash; free shipping over ${formatMoney(threshold)}`
      : '';
    return `
    <div class="pkcd-empty">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2 3h2.6l2.2 12h11.2l2-8H6.2"/>
      </svg>
      <p class="pkcd-empty__title">Your cart is empty</p>
      <p class="pkcd-empty__sub">Add something you&#39;ll love${note}.</p>
    </div>
  `;
  }

  // Free shipping threshold in cents, configured in snippets/cart-drawer.liquid
  function getShippingThreshold() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return 0;
    const value = parseInt(drawer.getAttribute('data-free-shipping-threshold'), 10);
    return isNaN(value) ? 0 : value;
  }


  // Helper function to replace all occurrences
  function replaceAll(str, find, replace) {
    return str.split(find).join(replace);
  }

  // Format money helper
  function formatMoney(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  // ---------------------------------------------------------------------------
  // Focus management for the modal dialog.
  //
  // The drawer is role="dialog" aria-modal="true", which tells assistive tech the
  // rest of the page is inert. That promise has to be kept for keyboard users too:
  // focus moves into the panel on open, Tab is trapped inside it while open, and
  // the opening element gets focus back on close.
  //
  // State lives on `window` rather than in this closure because initScripts()
  // re-runs initCartDrawer() on `shopify:section:load`, which would otherwise
  // strand the already-bound listeners on a stale closure.
  // ---------------------------------------------------------------------------
  const FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  // Read the open state off the DOM instead of a closure variable so it stays
  // correct across re-initialisation.
  function cartIsOpen() {
    const drawer = document.getElementById('cart-drawer');
    return !!drawer && drawer.getAttribute('aria-hidden') === 'false';
  }

  // Several PDP templates hide this drawer outright with
  // `#cart-drawer { display: none }` so a third-party One Click Upsell drawer can
  // take over (snippets/product-form-gummies.liquid,
  // snippets/product.form-thc-gummies.liquid and friends). Nothing stops the
  // drawer being put into its aria-open state on those pages — `?open-cart=true`
  // runs unconditionally — so every behaviour that takes the page hostage (the
  // Tab trap, the body scroll lock, moving focus) must first check that the panel
  // is actually rendered. Detected from layout, not from a template allow-list.
  function drawerIsVisible(node) {
    const drawer = node || document.getElementById('cart-drawer');
    if (!drawer) return false;
    // `display: none` (on the drawer or any ancestor) and detached nodes both
    // produce no client rects. A closed drawer is only `visibility: hidden` +
    // translated, which still generates a box — so this stays true while closed,
    // which is what we want: it means "the drawer exists on this page".
    const rects = drawer.getClientRects();
    if (rects.length === 0) return false;
    return rects[0].width > 0 && rects[0].height > 0;
  }

  function getFocusableInDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return [];
    return Array.from(drawer.querySelectorAll(FOCUSABLE_SELECTOR)).filter((el) => {
      if (el.closest('[aria-hidden="true"]')) return false;
      // Rendered and not display:none — getClientRects() is safe here where
      // offsetParent is not, because the drawer itself is position:fixed.
      return el.getClientRects().length > 0;
    });
  }

  function trapFocus(event) {
    if (event.key !== 'Tab' || !cartIsOpen()) return;

    const drawer = document.getElementById('cart-drawer');
    if (!drawer || !drawerIsVisible(drawer)) return;

    // Nothing to trap onto (hidden panel, empty render): swallowing Tab here
    // would deadlock keyboard navigation for the whole page until Escape, so let
    // the browser move focus normally instead.
    const focusable = getFocusableInDrawer();
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;

    // Focus escaped the panel (or never entered it) — pull it back.
    if (!drawer.contains(active)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
      return;
    }

    if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  // After a mutation re-renders the list, put focus back on the control the user
  // was using: same line + same action if it survived, otherwise the first
  // remaining line control, otherwise the close button.
  function restoreLineFocus(lineKey, action) {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer || !cartIsOpen()) return;

    // Only intervene if the re-render actually dropped focus out of the dialog.
    const active = document.activeElement;
    if (active && active !== document.body && drawer.contains(active)) return;

    // Matched by attribute read rather than a selector: line keys contain a
    // colon and arbitrary hex, which is awkward to embed in one safely.
    const card = Array.prototype.find.call(
      drawer.querySelectorAll('#cart-items-container [data-cart-item-key]'),
      (el) => el.getAttribute('data-cart-item-key') === lineKey
    );

    const target =
      (card && card.querySelector('[data-cart-line-action="' + action + '"]')) ||
      (card && card.querySelector('[data-cart-line-action]')) ||
      drawer.querySelector('#cart-items-container [data-cart-line-action]') ||
      drawer.querySelector('[data-cart-drawer-close]');

    if (target) target.focus();
  }

  // Polite announcements for cart mutations. Nothing else in the drawer speaks:
  // the item list is swapped wholesale by renderCart(), which screen readers do
  // not report on their own.
  function announceCart(cart, action) {
    const region = document.querySelector('[data-cart-live]');
    if (!region || !cart) return;

    const count = Number(cart.item_count || 0);
    const lead = action === 'removed' ? 'Item removed.' : 'Cart updated.';

    if (count === 0) {
      region.textContent = lead + ' Your cart is empty.';
      return;
    }

    region.textContent =
      lead + ' ' + count + (count === 1 ? ' item' : ' items') +
      ' in cart. Total ' + formatMoney(cart.total_price) + '.';
  }

  // ---------------------------------------------------------------------------
  // Open / Close — single implementation. openCartDrawer/closeCartDrawer used to
  // be a second, conflicting implementation; they are now thin aliases.
  // ---------------------------------------------------------------------------
  function openCart() {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-drawer-overlay');

    if (!drawer || !overlay) return;

    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    isCartOpen = true;

    // Remember what opened the drawer so focus can go back there on close.
    // Ignore body/null so a programmatic open doesn't park focus on nothing.
    const trigger = document.activeElement;
    if (trigger && trigger !== document.body && typeof trigger.focus === 'function') {
      window.__pkCartLastFocus = trigger;
    }

    // Fetch latest cart data
    fetchCart();

    // Show cart drawer
    drawer.style.opacity = '1';
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.remove('visibility-hidden', 'pointer-events-none', 'translate-x-[110%]');
    drawer.classList.add('translate-x-0');

    // Show overlay
    overlay.classList.remove('pointer-events-none');
    overlay.style.opacity = '0.5';

    // Prevent body scroll — but only behind a panel the user can actually see.
    // On the OCU-takeover templates the drawer is `display: none` and locking
    // here would freeze the page (and stomp on the takeover drawer's own lock)
    // with nothing on screen to explain why. The flag makes closeCart() release
    // only the lock we took.
    if (drawerIsVisible(drawer)) {
      document.body.style.overflow = 'hidden';
      window.__pkCartScrollLocked = true;
    }

    // Move focus into the dialog. The close button is the safe target: it always
    // exists, and it reads as "Close cart" so the user knows where they landed.
    // Done synchronously (the panel is already past `visibility: hidden` by this
    // point) with a macrotask retry, because whatever triggered the open — a link
    // click, a form submit — can pull focus back afterwards. A timer rather than
    // requestAnimationFrame: rAF does not fire while the document is hidden.
    focusDrawer();
    setTimeout(focusDrawer, 0);
  }

  // Put focus inside the drawer if it isn't already there.
  function focusDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer || !cartIsOpen() || !drawerIsVisible(drawer)) return;
    if (drawer.contains(document.activeElement)) return;

    const closeButton = drawer.querySelector('[data-cart-drawer-close]');
    if (closeButton) {
      closeButton.focus();
      return;
    }

    const focusable = getFocusableInDrawer();
    if (focusable.length) focusable[0].focus();
  }

  function closeCart() {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-drawer-overlay');

    if (!drawer || !overlay) return;

    isCartOpen = false;

    // Move focus out before the panel is hidden, otherwise the browser drops it
    // to <body> and the user loses their place on the page.
    const returnTo = window.__pkCartLastFocus;
    if (drawer.contains(document.activeElement)) {
      if (returnTo && document.contains(returnTo) && returnTo.getClientRects().length > 0) {
        returnTo.focus();
      } else if (document.activeElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
      }
    }
    window.__pkCartLastFocus = null;

    // Hide cart drawer
    drawer.classList.add('translate-x-[110%]');
    drawer.classList.remove('translate-x-0');
    drawer.setAttribute('aria-hidden', 'true');

    // Hide overlay
    overlay.style.opacity = '0';

    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      drawer.style.opacity = '0';
      drawer.classList.add('visibility-hidden', 'pointer-events-none');
      overlay.classList.add('pointer-events-none');
      closeTimer = null;
    }, 300);

    // Restore body scroll — only if this drawer is the one that locked it.
    if (window.__pkCartScrollLocked) {
      document.body.style.overflow = '';
      window.__pkCartScrollLocked = false;
    }
  }

  // Backwards-compatible aliases (older call sites used these names)
  const openCartDrawer = openCart;
  const closeCartDrawer = closeCart;

  // Fetch Cart
  async function fetchCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      renderCart(cart);
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  // Render Cart
  function renderCart(cart) {
    const cartItemHolder = document.getElementById('cart-items-container');
    const checkoutButton = document.querySelector('#cart-drawer [name="checkout"]');

    if (cartItemHolder) {
      cartItemHolder.innerHTML = '';

      if (!cart.items || cart.items.length === 0) {
        cartItemHolder.innerHTML = cartEmptyMarkup();
        if (checkoutButton) checkoutButton.disabled = true;
      } else {
        cart.items.forEach((item) => {
          const sellingPlanName = (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.name) || '';
          // `key` is present on every line /cart.js returns, and it is the only
          // valid handle for /cart/change.js. There is no meaningful fallback —
          // anything synthesised here would be neither a key nor a line index —
          // so on the impossible path say so and render the line inert (the
          // delegated handler bails on an empty key) rather than baking an id
          // that would silently mutate nothing, or the wrong line.
          const cartKey = item.key || '';
          if (!cartKey) {
            console.error('Cart drawer: line item has no `key`; its controls will be inert.', item);
          }

          // Check if item is BOGO (free item)
          const isBOGO = item.final_line_price === 0;

          let cartItemHTML = replaceAll(cartItem, '%PRODUCT_TITLE_ATTR%', escapeAttr(item.product_title));
          cartItemHTML = replaceAll(cartItemHTML, '%PRODUCT_TITLE%', escapeHtml(item.product_title));
          cartItemHTML = replaceAll(cartItemHTML, '%CART_KEY%', escapeAttr(cartKey));
          cartItemHTML = replaceAll(cartItemHTML, '%PRODUCT_IMAGE%', item.image ? escapeAttr(item.image.replace('.png', '_200x.png').replace('.jpg', '_200x.jpg')) : '');
          cartItemHTML = replaceAll(cartItemHTML, '%PRODUCT_URL%', escapeAttr(item.url));

          // BOGO Badge
          const bogoBadge = isBOGO
            ? `<span class="pkcd-pill">BOGO</span>`
            : '';
          cartItemHTML = replaceAll(cartItemHTML, '%BOGO_BADGE%', bogoBadge);

          // Price formatting. Savings are conveyed by the struck-through original
          // price sitting beside the current one at the same size — no badge.
          const price = formatMoney(item.final_line_price);
          const hasDiscount = item.original_line_price > item.final_line_price;

          if (hasDiscount) {
            const originalPrice = formatMoney(item.original_line_price);
            cartItemHTML = replaceAll(cartItemHTML, '%PRODUCT_PRICE%', `<span>${price}</span><s>${originalPrice}</s>`);
          } else {
            cartItemHTML = replaceAll(cartItemHTML, '%PRODUCT_PRICE%', `<span>${price}</span>`);
          }

          // Selling Plan Text (subscription name + discount %)
          let sellingPlanText = '';
          if (sellingPlanName) {
            let discountText = '';
            if (item.original_line_price > item.final_line_price && item.original_line_price > 0) {
              const discountPercent = Math.round(((item.original_line_price - item.final_line_price) / item.original_line_price) * 100);
              discountText = ` &middot; Save ${discountPercent}%`;
            }
            sellingPlanText = `<p class="pkcd-item__meta">${escapeHtml(sellingPlanName)}${discountText}</p>`;
          }
          cartItemHTML = replaceAll(cartItemHTML, '%SELLING_PLAN_TEXT%', sellingPlanText);

          // Quantity stepper — locked (no +/-) for free BOGO lines.
          // The buttons carry the line's current quantity so the delegated handler
          // can step from it without another lookup; the line itself is identified
          // by the card's data-cart-item-key.
          const quantity = item.quantity;

          let quantityControl;
          if (isBOGO) {
            quantityControl = `<div class="pkcd-qty is-locked">
                <span class="pkcd-qty__val">${quantity}</span>
              </div>`;
          } else {
            quantityControl = `<div class="pkcd-qty">
                <button type="button" class="pkcd-qty__btn" aria-label="Decrease quantity" data-cart-line-action="decrease" data-cart-line-qty="${quantity}">&minus;</button>
                <span class="pkcd-qty__val">${quantity}</span>
                <button type="button" class="pkcd-qty__btn" aria-label="Increase quantity" data-cart-line-action="increase" data-cart-line-qty="${quantity}">+</button>
              </div>`;
          }
          cartItemHTML = replaceAll(cartItemHTML, '%QUANTITY_CONTROL%', quantityControl);

          // Variant title
          const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="pkcd-item__meta">${escapeHtml(item.variant_title)}</p>`
            : '';
          cartItemHTML = replaceAll(cartItemHTML, '%VARIANT_TITLE%', variantTitle);

          cartItemHolder.insertAdjacentHTML('beforeend', cartItemHTML);
        });

        if (checkoutButton) checkoutButton.disabled = false;
      }
    }

    // Update cart count badge in the header
    const cartCount = document.querySelector('.cart-count');
    if (cartCount) {
      if (cart.item_count > 0) {
        cartCount.textContent = cart.item_count;
        cartCount.style.display = 'flex';
      } else {
        cartCount.style.display = 'none';
      }
    }

    updateCartSummary(cart);
  }

  // Footer summary: shipping progress -> discount -> total -> checkout CTA.
  // Order and visibility rules live in snippets/cart-drawer.liquid.
  function updateCartSummary(cart) {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    const total = Number(cart.total_price || 0);
    const discount = Number(cart.total_discount || 0);
    const itemCount = Number(cart.item_count || 0);

    // 3. Total
    drawer.querySelectorAll('[data-cart-total]').forEach((el) => {
      el.textContent = formatMoney(total);
    });

    // 2. Discount — row is removed from the layout entirely when there is none
    const discountRow = drawer.querySelector('[data-cart-discount-row]');
    if (discountRow) {
      if (discount > 0) {
        discountRow.hidden = false;
        const discountValue = discountRow.querySelector('[data-cart-discount]');
        if (discountValue) discountValue.textContent = '-' + formatMoney(discount);
      } else {
        discountRow.hidden = true;
      }
    }

    // 1. Free shipping progress. Threshold (in cents) comes from the Liquid
    // template via data-free-shipping-threshold so it stays configurable.
    const shipping = drawer.querySelector('[data-cart-shipping]');
    const threshold = getShippingThreshold();

    if (shipping && threshold > 0) {
      const message = shipping.querySelector('[data-cart-shipping-msg]');
      const remaining = Math.max(0, threshold - total);
      // Any subscription line earns free shipping regardless of the threshold.
      const hasSubscription = (cart.items || []).some((item) => item.selling_plan_allocation);

      // The earned state is intentionally identical in treatment — the shipping
      // and discount rows use a bolder body colour, never a green/accent. Only
      // the copy changes, so there is no state class to toggle.
      if (itemCount > 0 && (hasSubscription || remaining <= 0)) {
        if (message) message.textContent = 'FREE SHIPPING';
      } else if (message) {
        message.textContent = 'Add ' + formatMoney(remaining) + ' more to get free shipping';
      }
    }
  }

  // Add to Cart
  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .catch(error => console.error('Error adding to cart:', error));
  }

  // Remove from Cart
  function removeCart(variantId) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    })
    .then(response => response.json())
    .catch(error => console.error('Error removing from cart:', error));
  }

  // No upper bound: Shopify enforces inventory and any variant quantity rules
  // on /cart/change.js, and a client-side cap silently rewrote quantities that
  // the add-to-cart paths had already let through (10 + "+" landed on 8).
  function clampQty(quantity) {
    let qty = parseInt(quantity, 10);
    if (!isFinite(qty) || qty < 0) qty = 0;
    return qty;
  }

  // A /cart.js line key looks like "48836734845168:5f1e...". Variant ids are plain
  // digits, so the colon is what tells the two apart when changeItem() is handed
  // either one.
  function isLineKey(value) {
    return typeof value === 'string' && value.indexOf(':') !== -1;
  }

  // In-flight mutation state, keyed by line key: the target quantity a pending
  // /cart/change.js call is heading for. Read by the delegated +/- handler so a
  // second activation steps from the pending target instead of the stale
  // quantity baked into the freshly-rendered button. `mutationQueue` serialises
  // the calls so two POSTs for the same line cannot resolve out of order.
  const pendingQty = Object.create(null);
  let mutationQueue = Promise.resolve();

  // ---------------------------------------------------------------------------
  // Change a single cart line, addressed by its line key.
  //
  // /cart/change.js accepts `{ id: "<line key>", quantity: N }`, where the key is
  // `item.key` from /cart.js. That is the only unambiguous handle on a line: a
  // cart can hold several lines of the SAME variant and selling plan (the BOGO
  // path adds a paid line with properties plus a free line without; the bulk
  // promotion splits lines as well), and any variant-id or index lookup resolves
  // to the first match and mutates the wrong line.
  //
  // Quantity 0 removes the line. The response is the full cart, so we re-render
  // straight from it; on any failure we fall back to a fresh /cart.js render so
  // the drawer never sits on stale items.
  // ---------------------------------------------------------------------------
  function changeItemByKey(lineKey, quantity) {
    if (!lineKey) return Promise.resolve();

    const qty = clampQty(quantity);
    const cartItemsContainer = document.getElementById('cart-items-container');
    if (cartItemsContainer) {
      cartItemsContainer.classList.add('loading');
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        id: String(lineKey),
        quantity: qty
      })
    })
      .then(response => {
        // A 404/422 body is an error object, not a cart — rendering it would blank
        // the drawer. Throw so the catch below re-syncs from /cart.js instead.
        if (!response.ok) throw new Error('cart/change.js responded ' + response.status);
        return response.json();
      })
      .then(cart => {
        renderCart(cart);
        announceCart(cart, qty === 0 ? 'removed' : 'updated');
      })
      .catch(error => {
        console.error('Error changing item:', error);
        // Re-sync rather than leaving stale cards on screen (e.g. the line was
        // already gone because another tab emptied the cart).
        return fetchCart();
      })
      .finally(() => {
        if (cartItemsContainer) {
          cartItemsContainer.classList.remove('loading');
        }
      });
  }

  // Legacy entry point, kept because other files/snippets may call
  // window.changeItem(variantId, qty, planId). Prefer changeItemByKey().
  // When handed a line key it delegates straight to the key path; otherwise it
  // resolves the first line matching (variant id, selling plan id) — ambiguous by
  // nature, which is exactly why the drawer's own cards no longer use it.
  function changeItem(productId, quantity, sellingPlanId = null) {
    if (isLineKey(productId)) {
      return changeItemByKey(productId, quantity);
    }

    const qty = clampQty(quantity);

    // Normalize sellingPlanId
    if (sellingPlanId === 'null' || sellingPlanId === 'undefined' || sellingPlanId === '') {
      sellingPlanId = null;
    }

    const cartItemsContainer = document.getElementById('cart-items-container');
    if (cartItemsContainer) {
      cartItemsContainer.classList.add('loading');
    }

    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        let key = null;

        // Find the FIRST matching item
        for (let index = 0; index < cart.items.length; index++) {
          const item = cart.items[index];

          if (item.id === productId) {
            const itemHasSellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
            const itemSellingPlanId = itemHasSellingPlan ? item.selling_plan_allocation.selling_plan.id : null;

            const plansMatch = (sellingPlanId === null && itemSellingPlanId === null) ||
                              (sellingPlanId !== null && itemSellingPlanId === sellingPlanId);

            if (plansMatch) {
              key = item.key;
              break;
            }
          }
        }

        // No matching line (e.g. the cart was emptied in another tab): render what
        // the cart actually is now instead of throwing on an undefined response.
        if (key === null) {
          renderCart(cart);
          return;
        }

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({
            id: String(key),
            quantity: qty
          })
        })
          .then(response => {
            if (!response.ok) throw new Error('cart/change.js responded ' + response.status);
            return response.json();
          })
          .then(updatedCart => {
            renderCart(updatedCart);
            announceCart(updatedCart, qty === 0 ? 'removed' : 'updated');
          });
      })
      .catch(error => {
        console.error('Error changing item:', error);
        return fetchCart();
      })
      .finally(() => {
        if (cartItemsContainer) {
          cartItemsContainer.classList.remove('loading');
        }
      });
  }

  // Add Quantity
  function addQty(productId, quantity, sellingPlanId = null) {
    const newQuantity = clampQty(quantity) + 1;
    return changeItem(productId, newQuantity, sellingPlanId);
  }

  // Subtract Quantity
  function subQty(productId, quantity, sellingPlanId = null) {
    const newQuantity = Math.max(clampQty(quantity) - 1, 0);
    return changeItem(productId, newQuantity, sellingPlanId);
  }

  // Initialize Cart Events.
  // initScripts() re-runs on `shopify:section:load`, so guard the document-level
  // listeners to avoid stacking duplicates.
  function initCart() {
    if (window.__pkCartDrawerBound) return;
    window.__pkCartDrawerBound = true;

    // Cart drawer close button ("X" in the sticky header)
    const closeButton = document.querySelector('[data-cart-drawer-close]');
    if (closeButton) {
      closeButton.addEventListener('click', closeCart);
    }

    // Cart overlay
    const overlay = document.getElementById('cart-drawer-overlay');
    if (overlay) {
      overlay.addEventListener('click', closeCart);
    }

    // Cart open triggers: [data-cart-open] and the header cart icon
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-open], #cart-icon-link')) {
        e.preventDefault();
        openCart();
      }
    });

    // Line item +/- and remove. Bound once on `document` (not on the injected
    // markup) because renderCart() replaces the whole list on every change — a
    // delegated listener survives every re-render, and this guarded initCart()
    // means it is never stacked twice.
    document.addEventListener('click', (e) => {
      const button = e.target.closest('#cart-items-container [data-cart-line-action]');
      if (!button) return;

      e.preventDefault();

      const card = button.closest('[data-cart-item-key]');
      const lineKey = card && card.getAttribute('data-cart-item-key');
      if (!lineKey) return;

      const action = button.getAttribute('data-cart-line-action');

      // The button's data-cart-line-qty is the quantity as of the LAST render, so
      // a second activation before the re-render lands would re-send the same
      // target and collapse two presses into one ("+ +" ending on 2, not 3).
      // `pendingQty` carries the optimistic target of any mutation still in
      // flight for this line, so rapid presses step from where the cart is going
      // rather than from where it was. (A `.loading` pointer-events guard cannot
      // do this job: it does not block keyboard activation, and dropping the
      // press is exactly the collapse we are fixing.)
      const baked = parseInt(button.getAttribute('data-cart-line-qty'), 10) || 0;
      const inFlight = Object.prototype.hasOwnProperty.call(pendingQty, lineKey);
      const current = inFlight ? pendingQty[lineKey] : baked;

      let next;
      if (action === 'remove') {
        next = 0;
      } else if (action === 'increase') {
        next = current + 1;
      } else if (action === 'decrease') {
        // Stepping below 1 removes the line, matching the old subQty() behaviour.
        next = current - 1;
      } else {
        return;
      }

      next = clampQty(next);

      // A second press that cannot move the target any further (a double-tapped
      // trash, "-" already queued at 0) is a no-op, not another POST against a
      // line key that may already be gone.
      if (inFlight && next === current) return;

      pendingQty[lineKey] = next;

      // Serialised: two overlapping /cart/change.js calls for the same line can
      // come back out of order, and the later render would win with the older
      // quantity. Queueing keeps the last press authoritative.
      // renderCart() also replaces the list, destroying the button that was just
      // clicked — the browser then drops focus to <body>, outside the dialog.
      // Put it back on the equivalent control, or the close button if the line
      // is gone, so keyboard users keep their place.
      mutationQueue = mutationQueue
        .then(() => changeItemByKey(lineKey, next))
        .then(() => {
          // Only clear if no newer press has superseded this target; that press
          // owns the entry and will clear it when it settles.
          if (pendingQty[lineKey] === next) delete pendingQty[lineKey];
          restoreLineFocus(lineKey, action);
        })
        .catch((error) => {
          delete pendingQty[lineKey];
          console.error('Error updating cart line:', error);
        });
    });

    // ESC key to close cart
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape' && cartIsOpen()) {
        closeCart();
      }
    });

    // Focus trap. keydown (not keyup) so the default tab move can be prevented.
    document.addEventListener('keydown', trapFocus);
  }

  // Handle Product Form Submissions.
  // Guarded for the same reason initCart() is: initScripts() re-runs
  // initCartDrawer() on `shopify:section:load`, and without this each section
  // reload in the theme customizer stacked another `submit` listener, firing N
  // parallel POSTs to /cart/add.js per submit and duplicating cart lines.
  function handleProductForms() {
    if (window.__pkProductFormsBound) return;
    window.__pkProductFormsBound = true;

    document.addEventListener('submit', async (e) => {
      if (e.target.matches('form[action*="/cart/add"]')) {
        e.preventDefault();

        const form = e.target;
        const formData = new FormData(form);
        const submitButton = form.querySelector('[data-product-form-btn]');
        const sectionId = submitButton ? submitButton.getAttribute('data-section-id') : null;
        
        // Show loading state
        if (submitButton) {
          submitButton.classList.add('loading');
          submitButton.disabled = true;
        }
        
        try {
          // Get quantity from form - check multiple sources
          let quantity = 1; // Default quantity
          let freeQuantity = 0;
          
          // 1. First, try to get from quantity-selector input (data-quantity-input)
          // This is the most reliable source as it reflects user's current selection
          // Check both inside the form AND in the parent element (product-box-v2 has it outside)
          let quantityInput = form.querySelector('[data-quantity-input]');
          
          // If not found inside form, check in parent container (for product-box-v2)
          if (!quantityInput) {
            const productBox = form.closest('[data-product-box]');
            if (productBox) {
              quantityInput = productBox.querySelector('[data-quantity-input]');
            }
          }
          
          if (quantityInput) {
            const qtyValue = parseInt(quantityInput.value);
            if (qtyValue && qtyValue > 0) {
              quantity = qtyValue;
            }
          }
          
          // 2. If still not found or is 1, try to get from formData (input hidden)
          if (quantity === 1) {
            const formQuantity = formData.get('quantity');
            if (formQuantity && parseInt(formQuantity) > 1) {
              quantity = parseInt(formQuantity) || 1;
            }
          }
          
          // 3. Try to find section by sectionId first (for BOGO sections)
          let section = null;
          if (sectionId) {
            section = document.getElementById(sectionId);
          }
          
          // If not found, try to find section by form's closest section or parent
          if (!section) {
            section = form.closest('section');
          }
          
          // If still not found, try to find by form ID (for CBD/THC sections)
          if (!section && form.id) {
            if (form.id.includes('cbd')) {
              section = document.getElementById('cbd-product-section');
            } else if (form.id.includes('thc')) {
              section = document.getElementById('thc-product-section');
            }
          }
          
          // 4. Check for BOGO quantity input in section (for BOGO forms)
          if (section) {
            const qtyInput = section.querySelector('.qty-input');
            if (qtyInput) {
              const sectionQty = parseInt(qtyInput.value) || 1;
              quantity = sectionQty;
              freeQuantity = sectionQty; // BOGO: same quantity for free items
            }
          }
          
          // Ensure quantity is at least 1
          if (quantity < 1) {
            quantity = 1;
          }
          
          // Get variant ID and selling plan
          const variantId = formData.get('id');
          let sellingPlan = formData.get('selling_plan');
          
          // If not in formData, try to get from checked radio in parent (for product-box-v2)
          if (!sellingPlan || sellingPlan === '') {
            const productBox = form.closest('[data-product-box]');
            if (productBox) {
              const checkedSNS = productBox.querySelector('input[name="selling_plan"]:checked');
              if (checkedSNS) {
                sellingPlan = checkedSNS.value;
              }
            }
          }
          
          // Check if selling_plan is empty string or null (one-time purchase)
          if (sellingPlan === '' || sellingPlan === null || sellingPlan === 'null') {
            sellingPlan = null;
          }
          
          
          // Validate selling_plan format (should be numeric ID)
          if (sellingPlan && typeof sellingPlan === 'string') {
            // If it starts with "gid://", extract just the numeric ID
            if (sellingPlan.includes('gid://')) {
              const matches = sellingPlan.match(/\d+$/);
              if (matches) {
                sellingPlan = parseInt(matches[0]);
              }
            } else {
              // Try to parse as integer
              const numericPlan = parseInt(sellingPlan);
              if (!isNaN(numericPlan)) {
                sellingPlan = numericPlan;
              }
            }
          }
          
          // Prepare items array for BOGO
          const items = [];
          
          // Line item properties (properties[Key]) carry flags the discount/cart layer
          // reads, e.g. properties[_promotion_name]. Collected here so both the items-array
          // and the clean-FormData paths below preserve them.
          const lineProperties = {};
          for (const [key, value] of formData.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && value !== '') {
              lineProperties[match[1]] = value;
            }
          }
          const hasLineProperties = Object.keys(lineProperties).length > 0;

          // Add main product with quantity
          items.push({
            id: variantId,
            quantity: quantity,
            ...(sellingPlan && { selling_plan: sellingPlan }),
            ...(hasLineProperties && { properties: lineProperties })
          });
          
          // Add free items (BOGO) - same variant, same quantity, no selling plan (free items are usually one-time)
          if (freeQuantity > 0) {
            items.push({
              id: variantId,
              quantity: freeQuantity
              // Note: Free items typically don't have selling plans
            });
          }
          
          // Use items array if we have BOGO, otherwise use formData with quantity
          let requestBody;
          let headers = {};
          
          if (freeQuantity > 0 && items.length > 1) {
            // BOGO: use items array
            requestBody = JSON.stringify({ items: items });
            headers['Content-Type'] = 'application/json';
          } else {
            // Regular add to cart: ensure quantity is in formData and updated
            // Remove existing quantity if present, then add the correct one
            if (formData.has('quantity')) {
              formData.delete('quantity');
            }
            formData.append('quantity', quantity);
            
            // Remove selling_plan_frequency if present (not supported by Shopify)
            if (formData.has('selling_plan_frequency')) {
              formData.delete('selling_plan_frequency');
            }
            
            // Remove selling_plan if it's empty string (Shopify doesn't accept empty string)
            if (formData.has('selling_plan')) {
              const planValue = formData.get('selling_plan');
              if (planValue === '' || planValue === 'null' || planValue === null) {
                formData.delete('selling_plan');
              }
            }
            
            // Also update the hidden input in the form if it exists
            const hiddenQtyInput = form.querySelector('input[name="quantity"][type="hidden"]');
            if (hiddenQtyInput) {
              hiddenQtyInput.value = quantity;
            }
            
            // Create clean FormData with only required fields
            const cleanFormData = new FormData();
            cleanFormData.append('id', variantId);
            cleanFormData.append('quantity', quantity);
            
            // Only add selling_plan if it has a valid value
            if (sellingPlan && sellingPlan !== '' && sellingPlan !== 'null') {
              cleanFormData.append('selling_plan', sellingPlan);
            }

            // Carry line item properties through the rebuild
            Object.keys(lineProperties).forEach((key) => {
              cleanFormData.append('properties[' + key + ']', lineProperties[key]);
            });

            requestBody = cleanFormData;
          }
          
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: headers,
            body: requestBody
          });
          
          if (response.ok) {
            // Small delay to show loading animation
            await new Promise(resolve => setTimeout(resolve, 300));
            
            // Open cart drawer after adding item
            openCart();
          } else {
            const errorData = await response.json().catch(() => ({}));
            console.error('Error adding to cart:', errorData);
            alert(errorData.description || errorData.message || 'Error adding product to cart');
          }
        } catch (error) {
          console.error('Error:', error);
          alert('Error adding product to cart');
        } finally {
          // Remove loading state
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.disabled = false;
          }
        }
      }
    });
  }

  // Initialize Cart on DOM Load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCart();
      handleProductForms();
    });
  } else {
    initCart();
    handleProductForms();
  }


  // Export functions to global scope
  window.openCart = openCart;
  window.closeCart = closeCart;
  window.fetchCart = fetchCart;
  window.addToCart = addToCart;
  window.removeCart = removeCart;
  window.changeItem = changeItem;
  window.changeItemByKey = changeItemByKey;
  window.addQty = addQty;
  window.subQty = subQty;
  // Legacy aliases kept for backwards compatibility with older call sites
  window.openCartDrawer = openCart;
  window.closeCartDrawer = closeCart;

  // NOTE: the close button, overlay click and ESC handling are all bound once in
  // initCart() above. The header cart icon (#cart-icon-link) is covered by the
  // delegated [data-cart-open], #cart-icon-link click handler there too.

  // Check URL parameter to auto-open cart
  function checkOpenCartParam() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('open-cart') === 'true') {
      // Small delay to ensure cart is fully initialized
      setTimeout(function() {
        openCartDrawer();
        
        // Optionally remove the parameter from URL without reload
        const newUrl = new URL(window.location);
        newUrl.searchParams.delete('open-cart');
        window.history.replaceState({}, '', newUrl);
      }, 300);
    }
  }

  // Initialize auto-open cart check on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkOpenCartParam);
  } else {
    checkOpenCartParam();
  }

  // NOTE: the former [data-cart-update] / [data-cart-remove] delegated handlers
  // were removed. Nothing rendered by renderCart() emits those attributes, and both
  // handlers called updateCartContent(), a function that does not exist in this theme
  // (every click through them threw a ReferenceError). Quantity and removal go through
  // addQty()/subQty()/changeItem(), which re-render via renderCart().
}


// Initialize Best Sellers Carousel
function initBestSellersCarousel() {
	'use strict';

	// Function to ensure jQuery is available
	function ensureJQuery(callback) {
		function tryInit() {
			if (typeof jQuery !== 'undefined') {
				callback(jQuery);
				return true;
			} else if (typeof $ !== 'undefined' && $.fn && $.fn.jquery) {
				callback($);
				return true;
			}
			return false;
		}
		
		if (!tryInit()) {
			// Load jQuery if not available
			if (typeof jQuery === 'undefined' && typeof $ === 'undefined') {
				var script = document.createElement('script');
				script.src = 'https://code.jquery.com/jquery-3.7.1.min.js';
				script.integrity = 'sha256-/JqT3SQfawRcv/BIHPThkBvs0OEvtFFmqPF/lYI/Cxo=';
				script.crossOrigin = 'anonymous';
				document.head.appendChild(script);
			}
			
			// Wait for jQuery to load
			var checkInterval = setInterval(function() {
				if (tryInit()) {
					clearInterval(checkInterval);
				}
			}, 50);
			
			// Timeout after 5 seconds
			setTimeout(function() {
				clearInterval(checkInterval);
				if (!tryInit()) {
					console.warn('jQuery was not loaded for best-sellers carousel');
				}
			}, 5000);
		}
	}

	function initBestSellersCarouselLogic($) {
		var $carousel = $('.bestsellers-carousel');
		var $wrapper = $('.bestsellers-carousel-wrapper');
		var $container = $('.bestsellers-carousel-container');
		var $progress = $('.bestsellers-progress');
		
		if ($carousel.length === 0 || $wrapper.length === 0) {
			return;
		}

		// Responsive settings (exactly like Swiper)
		var breakpoints = {
			default: { slidesPerView: 1.1, spaceBetween: 15 },
			575: { slidesPerView: 1.5, spaceBetween: 15 },
			767: { slidesPerView: 2, spaceBetween: 20 },
			1200: { slidesPerView: 2.5, spaceBetween: 25 },
			1440: { slidesPerView: 3, spaceBetween: 30 }
		};

		// Function to get current configuration based on screen width
		function getCurrentConfig() {
			var width = $(window).width();
			if (width >= 1440) return breakpoints[1440];
			if (width >= 1200) return breakpoints[1200];
			if (width >= 767) return breakpoints[767];
			if (width >= 575) return breakpoints[575];
			return breakpoints.default;
		}

		// Function to calculate slide width
		function calculateSlideWidth() {
			var config = getCurrentConfig();
			// Get container width (which has the correct width)
			var containerWidth = $container.width();
			// If not possible, try wrapper or parent
			if (!containerWidth || containerWidth === 0) {
				containerWidth = $wrapper.width() || $container.parent().width() || $(window).width();
			}
			var spaceBetween = config.spaceBetween;
			var slidesPerView = config.slidesPerView;
			
			// Calculate width of each slide
			var totalSpaces = (slidesPerView - 1) * spaceBetween;
			var slideWidth = (containerWidth - totalSpaces) / slidesPerView;
			
			return {
				slideWidth: slideWidth,
				spaceBetween: spaceBetween,
				slidesPerView: slidesPerView
			};
		}

		// Apply styles to slides
		function updateSlides() {
			var calc = calculateSlideWidth();
			var $slides = $carousel.find('.bestsellers-slide');
			
			$slides.css({
				'width': calc.slideWidth + 'px',
				'flex-shrink': '0'
			});
			
			// Apply margin-right to all except the last one
			$slides.not(':last-child').css('margin-right', calc.spaceBetween + 'px');
			$slides.last().css('margin-right', '0');

			// Update total carousel width
			var totalWidth = ($slides.length * calc.slideWidth) + (($slides.length - 1) * calc.spaceBetween);
			$carousel.css('width', totalWidth + 'px');
			
			// Update progressbar
			updateProgressbar();
		}

		// Update progressbar
		function updateProgressbar() {
			var scrollLeft = $wrapper.scrollLeft();
			var scrollWidth = $carousel[0].scrollWidth;
			var clientWidth = $wrapper[0].clientWidth;
			var scrollable = scrollWidth - clientWidth;
			
			if (scrollable > 0) {
				var progress = Math.min(100, (scrollLeft / scrollable) * 100);
				$progress.css('width', progress + '%');
			} else {
				$progress.css('width', '100%');
			}
		}

		// Configure carousel
		$carousel.css({
			'display': 'flex',
			'transition': 'transform 0.3s ease'
		});

		// Ensure wrapper has 100% width
		$wrapper.css({
			'width': '100%',
			'overflow-x': 'auto',
			'overflow-y': 'hidden',
			'scroll-behavior': 'smooth',
			'-webkit-overflow-scrolling': 'touch'
		});

		// Mousewheel horizontal (forceToAxis: true - horizontal axis only)
		var isScrolling = false;
		var lastWheelTime = 0;
		
		$wrapper.on('wheel', function(e) {
			var originalEvent = e.originalEvent || e;
			var deltaY = originalEvent.deltaY;
			var deltaX = originalEvent.deltaX;
			
			// If there's vertical movement, convert to horizontal
			if (Math.abs(deltaY) > Math.abs(deltaX) && deltaY !== 0) {
				e.preventDefault();
				e.stopPropagation();
				
				var now = Date.now();
				if (now - lastWheelTime < 16) return; // Throttle to ~60fps
				lastWheelTime = now;
				
				if (!isScrolling) {
					isScrolling = true;
					var scrollAmount = deltaY * 0.5; // Scroll speed
					
					$wrapper[0].scrollBy({
						left: scrollAmount,
						behavior: 'auto'
					});
					
					setTimeout(function() {
						isScrolling = false;
					}, 50);
				}
			}
		});

		// Update progressbar on scroll
		$wrapper.on('scroll', function() {
			updateProgressbar();
		});

		// Wait one frame to ensure layout is rendered
		setTimeout(function() {
			updateSlides();
		}, 0);

		// Update on resize
		var resizeTimer;
		$(window).on('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				updateSlides();
			}, 100);
		});
		
		// Update when images load (may change size)
		$carousel.find('img').on('load', function() {
			setTimeout(function() {
				updateSlides();
			}, 50);
		});
	}

	// Initialize when jQuery is ready
	ensureJQuery(function($) {
		if (document.readyState === 'loading') {
			$(document).ready(function() {
				initBestSellersCarouselLogic($);
			});
		} else {
			initBestSellersCarouselLogic($);
		}
	});
}

// Initialize Testimonials Swiper
function initTestimonialsSwiper(retryCount) {
	retryCount = retryCount || 0;
	const maxRetries = 20; // Maximum of 2 seconds (20 * 100ms)

	// Check if Swiper is available
	if (typeof Swiper === 'undefined') {
		if (retryCount < maxRetries) {
			setTimeout(function() {
				initTestimonialsSwiper(retryCount + 1);
			}, 100);
		}
		return;
	}

	const testimonialsSwiper = document.querySelector('.testimonials-swiper');
	if (!testimonialsSwiper) {
		// Try again after a delay if element doesn't exist yet
		if (retryCount < maxRetries) {
			setTimeout(function() {
				initTestimonialsSwiper(retryCount + 1);
			}, 100);
		}
		return;
	}

	// Check if already initialized
	if (testimonialsSwiper.swiper) {
		return;
	}

	// Find pagination element - try multiple strategies
	let paginationEl = testimonialsSwiper.parentElement?.querySelector('.testimonials-pagination');
	if (!paginationEl) {
		paginationEl = testimonialsSwiper.closest('.relative')?.querySelector('.testimonials-pagination');
	}
	if (!paginationEl) {
		paginationEl = document.querySelector('.testimonials-pagination');
	}
	
	if (!paginationEl) {
		// Try again if pagination was not found
		if (retryCount < maxRetries) {
			setTimeout(function() {
				initTestimonialsSwiper(retryCount + 1);
			}, 100);
		}
		return;
	}

	let activeSlideIndex = 0;
	let swiperInstance = null;

	function updateThumbnails() {
		const section = testimonialsSwiper.closest('section');
		if (!section) return;
		
		const colorTheme = section.dataset.colorTheme || '#6E886E';
		const thumbs = section.querySelectorAll('.testimonial-thumb');
		
		if (thumbs.length === 0) return;
		
		thumbs.forEach(function(thumb, index) {
			if (index === activeSlideIndex) {
				thumb.classList.add('scale-110');
				thumb.style.borderColor = colorTheme;
				thumb.style.opacity = '1';
			} else {
				thumb.classList.remove('scale-110');
				thumb.style.borderColor = '';
				thumb.style.opacity = '0.6';
			}
		});
	}

	try {
		swiperInstance = new Swiper(testimonialsSwiper, {
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			spaceBetween: 0,
			slidesPerView: 1,
			allowTouchMove: false,
			simulateTouch: false,
			preventClicks: false,
			preventClicksPropagation: false,
			touchStartPreventDefault: false,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false
			},
			pagination: {
				el: paginationEl,
				clickable: true,
				renderBullet: function(index, className) {
					return '<span class="' + className + '" style="background-color: #000; opacity: 0.25; width: 0.45rem; min-width: 0.45rem; height: 0.45rem; margin: 0; padding: 0; cursor: pointer;"></span>';
				}
			},
			on: {
				init: function() {
					updateThumbnails();
				},
				slideChange: function(swiper) {
					activeSlideIndex = swiper.activeIndex;
					updateThumbnails();
				}
			}
		});

		// Make goToTestimonialSlide available globally
		window.goToTestimonialSlide = function(index) {
			if (swiperInstance) {
				swiperInstance.slideTo(index);
			}
		};
	} catch (error) {
		console.error('Error initializing testimonials swiper:', error);
		// Try again on error
		if (retryCount < maxRetries) {
			setTimeout(function() {
				initTestimonialsSwiper(retryCount + 1);
			}, 200);
		}
	}
}

// Initialize Product NFP Swiper
function initProductNFPSwiper() {
	const productNFPSwiper = document.querySelector('.product-nfp-swiper');
	if (productNFPSwiper && !productNFPSwiper.swiper) {
		if (typeof Swiper === 'undefined') {
			setTimeout(initProductNFPSwiper, 100);
			return;
		}

		const swiper = new Swiper(productNFPSwiper, {
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			spaceBetween: 0,
			slidesPerView: 1,
			pagination: {
				el: '.product-nfp-pagination',
				clickable: true,
				renderBullet: function(index, className) {
					return '<span class="' + className + '" style="background-color: #000; opacity: 0.25; width: 0.45rem; min-width: 0.45rem; height: 0.45rem; margin: 0; padding: 0; cursor: pointer;"></span>';
				}
			}
		});
	}
}

// Initialize Product Block Swiper (THC and CBD Gummies)
function initProductBlockSwiper() {
	// Check if Swiper is available
	if (typeof Swiper === 'undefined') {
		setTimeout(initProductBlockSwiper, 100);
		return;
	}

	// Find all product block swipers (both THC and CBD)
	const productBlockSwipers = document.querySelectorAll('.swiper.swiper-fade');
	
	productBlockSwipers.forEach(function(swiperEl) {
		// Skip if already initialized
		if (swiperEl.swiper) {
			return;
		}

		// Find pagination element - look for the element with swiper-pagination classes
		let paginationEl = null;
		
		// Try to find pagination in the parent container
		const parentContainer = swiperEl.closest('.relative');
		if (parentContainer) {
			paginationEl = parentContainer.querySelector('.swiper-pagination-clickable');
		}
		
		// If not found, try to find it by class
		if (!paginationEl) {
			paginationEl = swiperEl.parentElement?.querySelector('.swiper-pagination-clickable');
		}

		// Initialize swiper
		try {
			const swiperInstance = new Swiper(swiperEl, {
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				spaceBetween: 0,
				slidesPerView: 1,
				allowTouchMove: true,
				pagination: paginationEl ? {
					el: paginationEl,
					clickable: true,
					renderBullet: function(index, className) {
						return '<span class="' + className + '"></span>';
					}
				} : false
			});
		} catch (error) {
			console.warn('Error initializing product block swiper:', error);
		}
	});
}

// init magnetic buttons
function initMagneticButtons() {
	const buttons = document.querySelectorAll('.magnetic-button')

	buttons.forEach((button) => {
		// prevent double init
		if (button.dataset.gsapInit === 'true') return
		button.dataset.gsapInit = 'true'

		// allow the effect on desktop only
		if (window.innerWidth <= 540) return

		const strength = parseFloat(button.dataset.strength) || 50

		let bounding = null
		let rafId = null

		// cache bounding rect
		const updateBounding = () => {
			bounding = button.getBoundingClientRect()
		}

		// throttle bounding rect updates with RAF
		const throttledUpdateBounding = () => {
			if (rafId) return
			rafId = requestAnimationFrame(() => {
				updateBounding()
				rafId = null
			})
		}

		// initial bounding rect
		updateBounding()

		function moveMagnet(event) {
			if (!bounding) return

			const x =
				((event.clientX - bounding.left) / bounding.width - 0.5) *
				strength

			const y =
				((event.clientY - bounding.top) / bounding.height - 0.5) *
				strength

			gsap.to(button, {
				x,
				y,
				rotate: '0.001deg', // forces GPU rendering
				ease: 'power4.out',
				duration: 1.5
			})
		}

		function resetMagnet() {
			gsap.to(button, {
				x: 0,
				y: 0,
				ease: 'elastic.out(1, 0.4)',
				duration: 1.5
			})
		}

		button.addEventListener('mousemove', moveMagnet)
		button.addEventListener('mouseleave', resetMagnet)
		window.addEventListener('resize', throttledUpdateBounding, { passive: true })
		window.addEventListener('scroll', throttledUpdateBounding, { passive: true })
	})
}

// Initialize Contact Form
/*
function initContactForm() {
	var form = document.querySelector('.contact-form');
	if (!form) return;

	var submitButton = form.querySelector('[data-form-submit]');
	
	form.addEventListener('submit', function(e) {
		if (submitButton) {
			submitButton.disabled = true;
			submitButton.textContent = 'Sending...';
		}
	});

	// Re-enable button if form has errors (Shopify will reload page)
	if (form.querySelector('.form-error-message') && submitButton) {
		submitButton.disabled = false;
		submitButton.textContent = 'Send Message';
	}
}
*/

// init accordion (snippets/accordion.liquid)
function initAccordions() {
	const accordionItems = document.querySelectorAll('.faq-accordion-item')

	accordionItems.forEach((item) => {
		const button = item.querySelector('.faq-accordion-button')
		if (!button) return

		button.addEventListener('click', () => {
			item.classList.toggle('active')
		})
	})

  const categoriesAccordion = document.querySelectorAll('.collections-nav')

  categoriesAccordion.forEach((item) => {
		const button = item.querySelector('.open-categories')
		if (!button) return

		button.addEventListener('click', () => {
			item.classList.toggle('active')
		})
	})
}

// init scrolling images (snippets/scrolling-image.liquid)
function initScrollingImages() {
	const scrollingImages = document.querySelectorAll('.scrolling-image')

	scrollingImages.forEach((wrapper) => {
		if (wrapper.dataset.gsapInit === 'true') return
		wrapper.dataset.gsapInit = 'true'

		const container = wrapper.closest('.scrolling-image-container')
		const image = wrapper.querySelector('img')

		if (!container || !image) return

		const isDesktop = window.innerWidth > 768
		const calcSize = isDesktop
			? 'calc(100% + 7rem)'
			: 'calc(100% + 3rem)'
		const offset = isDesktop ? '-7rem' : '-3rem'

		gsap.set(image, {
			height: calcSize,
			display: 'block'
		})

		gsap.from(image, {
			y: offset,
			scrollTrigger: {
				trigger: container,
				scrub: 3,
				start: 'top bottom',
				end: 'bottom top',
				//markers: true
			}
		})
	})
}

// init image reveal (snippets/image-reveal.liquid)
function initImageReveal() {
	const reveals = document.querySelectorAll('.image-reveal')

	reveals.forEach((container) => {
		if (container.dataset.gsapInit === 'true') return
		container.dataset.gsapInit = 'true'

		const overlay = container.querySelector('.image-reveal__overlay')
		const image = container.querySelector('.image-reveal__image')

		if (!overlay || !image) return

		const timeline = gsap.timeline({ paused: true })

		timeline.set(image, {
			scale: 1.5
		})

		timeline.to(overlay, {
			width: '100%',
			ease: 'power4.inOut',
			duration: 0.75
		})

		timeline.to(overlay, {
			x: '100%',
			ease: 'power4.in',
			duration: 1
		})

		timeline.to(
			image,
			{
				visibility: 'visible',
				scale: 1,
				duration: 2.5,
				ease: 'power4.out'
			},
			'-=1'
		)

		ScrollTrigger.create({
			trigger: container,
			start: '0% 120%',
			end: '100% -20%',
			onEnter: () => timeline.play(),
			onLeaveBack: () => timeline.reverse(),
			//markers: true
		})
	})
}

// init stagger up
function initStaggerUp() {
	const staggerContainers = document.querySelectorAll('.stagger-up')

	staggerContainers.forEach((container) => {
		// prevent double init
		if (container.dataset.gsapInit === 'true') return
		container.dataset.gsapInit = 'true'

		const children = Array.from(container.children)
		if (!children.length) return

		const infinite = container.dataset.infinite === 'true'

		// initial state
		gsap.set(children, {
			opacity: 0,
			y: '20vh'
		})

		ScrollTrigger.batch(children, {
			start: '-50% 100%',
			onEnter: (elements) => {
				gsap.to(elements, {
					opacity: 1,
					y: 0,
					stagger: 0.15,
					duration: 0.5,
					ease: 'power2.out'
				})
			},
			...(infinite && {
				onLeaveBack: (elements) => {
					gsap.to(elements, {
						opacity: 0,
						y: '20vh',
						stagger: 0.15,
						duration: 0.5,
						ease: 'power2.in'
					})
				}
			})
		})
	})
}

// init animated counter
function initCounters() {
	const counters = document.querySelectorAll('.counter-number')

	counters.forEach((counter) => {
		// prevent double init
		if (counter.dataset.gsapInit === 'true') return
		counter.dataset.gsapInit = 'true'

		const finalValue = parseInt(counter.textContent.replace(/,/g, ''), 10)
		if (isNaN(finalValue)) return

		gsap.from(counter, {
			textContent: 0,
			duration: 3,
			ease: 'power2.inOut',
			modifiers: {
				textContent: (value) => Math.floor(value)
			},
			scrollTrigger: {
				trigger: counter,
				start: 'top 90%',
				toggleActions: 'play none none none',
				//markers: true
			}
		})
	})
}

// Initialize Banner Home Swiper
function initBannerHomeSwiper() {
	'use strict';
	
	// Check if Swiper is available
	if (typeof Swiper === 'undefined') {
		setTimeout(initBannerHomeSwiper, 100);
		return;
	}
	
	const bannerSwiperEl = document.querySelector('.banner-home-swiper');
	if (!bannerSwiperEl || bannerSwiperEl.swiper) {
		return;
	}
	
	// Initialize Swiper (without modules property - modules are included in bundle)
	try {
		const bannerSwiper = new Swiper('.banner-home-swiper', {
			spaceBetween: 0,
			slidesPerView: 1,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			allowTouchMove: false,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.banner-pagination',
				clickable: true,
			},
			loop: true,
		});
	} catch (error) {
		console.error('Error initializing banner swiper:', error);
	}
	
	// Magnetic Button Effect for banner
	const magneticButtons = document.querySelectorAll('[data-magnetic]');
	
	if (window.innerWidth > 540) {
		magneticButtons.forEach(function(button) {
			// Prevent double initialization
			if (button.dataset.magneticInit === 'true') return;
			button.dataset.magneticInit = 'true';
			
			button.addEventListener('mousemove', function(e) {
				var rect = this.getBoundingClientRect();
				var x = ((e.clientX - rect.left) / rect.width - 0.5) * 50;
				var y = ((e.clientY - rect.top) / rect.height - 0.5) * 50;
				
				if (typeof gsap !== 'undefined') {
					gsap.to(this, {
						x: x,
						y: y,
						rotate: '0.001deg',
						ease: 'power4.out',
						duration: 1.5
					});
				}
			});
			
			button.addEventListener('mouseleave', function() {
				if (typeof gsap !== 'undefined') {
					gsap.to(this, {
						x: 0,
						y: 0,
						ease: 'elastic.out(1, 0.3)',
						duration: 1.5
					});
				}
			});
		});
	}
}

// Initialize Categories Stagger Animation
function initCategoriesStagger() {
	'use strict';
	
	// Check if GSAP and ScrollTrigger are available
	if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
		setTimeout(initCategoriesStagger, 100);
		return;
	}
	
	// Register ScrollTrigger plugin
	if (gsap.registerPlugin) {
		gsap.registerPlugin(ScrollTrigger);
	}
	
	const staggerContainers = document.querySelectorAll('[data-stagger]');
	
	if (staggerContainers.length === 0) {
		return;
	}
	
	staggerContainers.forEach((container) => {
		// Prevent double initialization
		if (container.dataset.gsapInit === 'true') return;
		container.dataset.gsapInit = 'true';
		
		const children = Array.from(container.children);
		if (!children.length) return;
		
		// Set initial state
		gsap.set(children, {
			opacity: 0,
			y: '20vh'
		});
		
		// Create batch animation
		ScrollTrigger.batch(children, {
			start: '-50% 100%',
			onEnter: function(elements) {
				gsap.to(elements, {
					opacity: 1,
					y: 0,
					stagger: 0.15,
					duration: 0.5,
					ease: 'power2.out'
				});
			}
		});
	});
}

// init format numbers to US format
function formatUS() {
  const numbers = document.querySelectorAll('.number-us-format')

  numbers.forEach((el) => {
    const value = Number(el.textContent.trim())

    if (!Number.isNaN(value)) {
      el.textContent = value.toLocaleString('en-US')
    }
  })
}

// Initialize Age Gateway
function initAgeGateway() {
	'use strict';
	
	const gateway = document.getElementById('age-gateway');
	if (!gateway) return;
	
	// Get settings from data attributes
	const cookieMaxAge = parseInt(gateway.dataset.cookieMaxAge) || 30;
	const declineRedirectUrl = gateway.dataset.declineRedirectUrl || 'https://google.com';
	const gatewayEnabled = gateway.dataset.gatewayEnabled === 'true';

	// Don't show age gateway if disabled or on specific pages
	const disabledPaths = ['/pages/free-samples', '/pages/free-samples-age-gateway', '/pages/free-sleep-gummy-samples', '/pages/half-off', '/pages/half-off-tinctures', '/products/thc-sleep-gummies-bogo', '/pages/tinctures-bogo'];
	const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';

	// CBD product pages are not age gated (any handle containing "cbd")
	const isCbdProduct = /\/products\/[^/]*cbd/.test(currentPath);

	if (!gatewayEnabled || disabledPaths.includes(currentPath) || isCbdProduct) {
		return;
	}
	
	const AGE_GATE_COOKIE_NAME = 'age_gate_accepted';
	
	// Cookie helper functions
	function getCookie(name) {
		const value = '; ' + document.cookie;
		const parts = value.split('; ' + name + '=');
		if (parts.length === 2) return parts.pop().split(';').shift();
		return null;
	}
	
	function setCookie(name, value, days) {
		const expiresDate = new Date();
		expiresDate.setTime(expiresDate.getTime() + (days * 24 * 60 * 60 * 1000));
		const expires = 'expires=' + expiresDate.toUTCString();
		document.cookie = name + '=' + value + ';' + expires + ';path=/';
	}
	
	// Check if user has already accepted
	const hasAccepted = getCookie(AGE_GATE_COOKIE_NAME);
	
	if (!hasAccepted) {
		gateway.style.display = 'flex';
		document.body.style.overflow = 'hidden';
		
		// Handle accept button
		const acceptBtn = document.getElementById('age-gateway-accept');
		if (acceptBtn) {
			acceptBtn.addEventListener('click', function() {
				setCookie(AGE_GATE_COOKIE_NAME, 'true', cookieMaxAge);
				gateway.style.display = 'none';
				document.body.style.overflow = '';
			});
		}
		
		// Handle decline button
		const declineBtn = document.getElementById('age-gateway-decline');
		if (declineBtn) {
			declineBtn.addEventListener('click', function() {
				window.location.href = declineRedirectUrl;
			});
		}
		
		// Close on ESC key
		document.addEventListener('keydown', function(e) {
			if (e.key === 'Escape' && gateway.style.display === 'flex') {
				// Don't allow closing without selection
				// gateway.style.display = 'none';
			}
		});
	}
}

function initNewProductBox() {
  
  /**
   * QUANTITY CONTROLS (+ / −)
   */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-action]');
    if (!btn) return;

    const productBox = btn.closest('[data-product-box]');
    if (!productBox) return;

    const input = productBox.querySelector('[data-quantity-input]');
    if (!input) return;

    const min = parseInt(input.min || 1, 10);
    const max = parseInt(input.max || 9999, 10);
    let value = parseInt(input.value || min, 10);

    if (btn.dataset.qtyAction === 'increment') {
      if (value < max) value += 1;
    }

    if (btn.dataset.qtyAction === 'decrement') {
      if (value > min) value -= 1;
    }

    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /**
   * ADD TO CART (AJAX)
   */
  
  /*
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;

    e.preventDefault();

    const productBox = form.closest('[data-product-box]');
    const qtyInput = productBox?.querySelector('[data-quantity-input]');

    const button = form.querySelector('[data-product-form-btn]');
    const text = button.querySelector('.btn-text');
    const spinner = button.querySelector('.btn-icon-loading');

    if (button.classList.contains('loading')) return;

    button.classList.add('loading');
    button.disabled = true;

    if (text) text.style.display = 'none';
    if (spinner) spinner.classList.remove('hidden');

    const formData = new FormData(form);
    if (qtyInput) {
      formData.set('quantity', qtyInput.value);
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      });

      if (!res.ok) throw new Error('Add to cart failed');

      const data = await res.json();

      document.dispatchEvent(
        new CustomEvent('cart:updated', { detail: data })
      );

    } catch (err) {
      console.error(err);
    } finally {
      button.classList.remove('loading');
      button.disabled = false;

      if (text) text.style.display = '';
      if (spinner) spinner.classList.add('hidden');
    }
  });
  */
}

// init everything
function initScripts() {
  initNewProductBox()
	initSliders()
	initMobileMenu()
	initCartDrawer()
	initBestSellersCarousel()
	initTestimonialsSwiper()
	initProductNFPSwiper()
	initProductBlockSwiper()
	initBannerHomeSwiper()
	initCategoriesStagger()
	initAccordions()
	initScrollingImages()
	initMagneticButtons()
	//initContactForm()
	initImageReveal()
	initStaggerUp()
	initCounters()
	initAgeGateway()
  initFancybox()
  formatUS()
}

document.addEventListener("DOMContentLoaded", initScripts)
document.addEventListener("shopify:section:load", initScripts)
